module.exports = __webpack_public_path__ + "img/logo.b9424986.png";